import { render } from "./ListePlace.vue?vue&type=template&id=3c1480e8&ts=true"
import script from "./ListePlace.vue?vue&type=script&lang=ts"
export * from "./ListePlace.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__